import styled from "@emotion/styled";

export const ContentBodyContainer = styled.section`
  position: relative;
`;

export const InlinePaywallOverlayer = styled.div`
  position: absolute;
  inset-block-end: 0;

  inline-size: 100%;
  block-size: 200px;

  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #ffffff 63%);
`;
